// gets the full url params string, without bracket [] notation for arrays, because it is not supported by ASP.NET
function getUrlParamsString(objectParam: any) {
  const keys = Object.keys(objectParam);
  let paramString = '';
  keys.forEach((k, i) => {
    if (!Array.isArray(objectParam[k])) {
      paramString += getUrlParamString(k, i, objectParam[k]);
    } else {
      objectParam[k].forEach((v: any, j: number) => {
        paramString += getUrlParamString(k, (i || j), v);
      });
    }
  });
  return paramString;
}

// gets one url Param string, encoding special characters
function getUrlParamString(key: string, index: number, value: any) {
  return (index ? '&' : '') + encodeURIComponent(key) + '=' + encodeURIComponent(value);
}

const urlHelper = {
  getUrlParamsString
};

export default urlHelper;
